import { Position } from "geojson";
import { RanchDTO } from "seedgreen-shared/dtos/RanchDTO";
import { computed, ComputedRef, Ref } from "vue";

/**
 * Get a method for sorting ranches
 */
export function useRanchSortMethod(
	methodKey: Ref<RanchSortMethodKey>,
): ComputedRef<RanchSortMethod> {
	return computed(() => RanchSortMethods[methodKey.value]);
}

export interface RanchSortMethod {
	fn: (
		a: RanchDTO,
		b: RanchDTO,
		userPosition: Position | undefined,
	) => number;
	label: string;
}

export const RanchSortMethods = {
	name: {
		fn: (a: RanchDTO, b: RanchDTO) => {
			return a.name.localeCompare(b.name);
		},
		label: "Name",
	},
	grower: {
		fn: (a: RanchDTO, b: RanchDTO) => {
			return (a.growerName || "\uFFFF")
				.trim()
				.localeCompare((b.growerName || "\uFFFF").trim());
		},
		label: "Grower",
	},
};

export type RanchSortMethodKey = keyof typeof RanchSortMethods;
